<template>
  <header class="header">
    <div class="header-inner">
      <button class="mobile-register-btn" @click="openRegisterModal">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <line x1="19" y1="8" x2="19" y2="14"/>
          <line x1="16" y1="11" x2="22" y2="11"/>
        </svg>
      </button>

      <div class="logo">
        <router-link to="/">
          <img src="@/assets/logo/logo2.png" alt="로고" />
          <span class="logo-badge">10년 전세</span>
        </router-link>
      </div>

      <nav class="nav-pc">
        <ul class="nav-menu">
          <li class="nav-item" v-for="menu in menuList" :key="menu.title">
            <router-link :to="menu.path" class="nav-title">{{ menu.title }}</router-link>
          </li>
        </ul>
      </nav>

      <div class="phone-box">
        <a href="tel:1688-4084">1688-4084</a>
      </div>

      <button class="mobile-menu-btn" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <div class="nav-mobile" :class="{ open: isMobileMenuOpen }">
      <div class="mobile-menu-inner">
        <ul class="mobile-menu">
          <li v-for="menu in menuList" :key="menu.title" class="mobile-menu-item">
            <router-link :to="menu.path" class="mobile-menu-title" @click="closeMobileMenu">
              {{ menu.title }}
            </router-link>
          </li>
        </ul>
        <div class="mobile-phone">
          <a href="tel:1688-4084">1688-4084</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isMobileMenuOpen: false,
      menuList: [
        { title: '사업개요', path: '/overview' },
        { title: '입지환경', path: '/location' },
        { title: '프리미엄', path: '/premium' },
        { title: '오시는길', path: '/directions' },
        { title: '관심고객등록', path: '/support' }
      ]
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    },
    openRegisterModal() {
      window.dispatchEvent(new CustomEvent('open-register-modal'))
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.header-inner {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 40px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  flex-shrink: 0;
}

.logo a {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo img {
  height: 30px;
}

.logo-badge {
  font-size: 11px;
  font-weight: 700;
  color: var(--main-color1);
  border: 1.5px solid var(--main-color1);
  border-radius: 4px;
  padding: 2px 6px;
  letter-spacing: -0.3px;
  white-space: nowrap;
}

.nav-pc {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 5px;
}

.nav-item {
  position: relative;
}

.nav-title {
  display: block;
  padding: 12px 22px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  letter-spacing: -0.3px;
}

.nav-title:hover {
  color: var(--main-color1);
}

.phone-box {
  flex-shrink: 0;
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
  border-radius: 50px;
  padding: 12px 28px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.phone-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(44, 79, 126, 0.3);
}

.phone-box a {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 0.3px;
}

.mobile-register-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #333;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  gap: 6px;
  padding: 0;
}

.mobile-menu-btn span {
  display: block;
  width: 24px;
  height: 2px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 6px);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -6px);
}

.nav-mobile {
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  height: calc(100vh - 80px);
  background: #fff;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
}

.nav-mobile.open {
  transform: translateX(0);
}

.mobile-menu-inner {
  padding: 30px 25px;
}

.mobile-menu {
  list-style: none;
}

.mobile-menu-item {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-menu-title {
  display: block;
  width: 100%;
  padding: 20px 0;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  text-decoration: none;
  letter-spacing: -0.3px;
  transition: color 0.2s;
}

.mobile-menu-title:hover,
.mobile-menu-title:active {
  color: var(--main-color1);
}

.mobile-phone {
  margin-top: 40px;
  text-align: center;
}

.mobile-phone a {
  display: inline-block;
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
  color: #fff;
  padding: 16px 50px;
  border-radius: 50px;
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
}

@media (max-width: 1280px) {
  .header-inner {
    padding: 0 30px;
  }

  .nav-title {
    padding: 12px 16px;
    font-size: 15px;
  }
}

@media (max-width: 1024px) {
  .nav-pc,
  .phone-box {
    display: none;
  }

  .mobile-register-btn {
    display: flex;
    position: absolute;
    left: 20px;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .nav-mobile {
    display: block;
  }

  .header-inner {
    height: 65px;
    padding: 0 20px;
    justify-content: center;
  }

  .logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .logo a {
    gap: 5px;
  }

  .logo img {
    height: 20px;
  }

  .logo-badge {
    font-size: 9px;
    padding: 1px 4px;
    border-width: 1px;
  }

  .mobile-menu-btn {
    position: absolute;
    right: 20px;
  }

  .nav-mobile {
    top: 65px;
    height: calc(100vh - 65px);
  }
}
</style>